import Swal from "sweetalert2";
import TableAHSF from "../../Components/TableAHSF"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetReportStageByID } from "../../Redux/Reducers/ReportStage/Stages";
import { useEffect, useState } from "react";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import InformationAdministrativeCosts from "./InformationAdministrativeCosts";
import PopupAHSF from "../../Components/PopupAHSF";
import CommentPopup from "./CommentPopup";



const RS_AdminStrativeStage = (props) => {
    const [PopupComponentEditStatus, setPopupComponentEditStatus] =
        useState(false);
        const [PopupComponentCommentStatus, setPopupComponentCommentStatus] =
        useState(false);
    const [PR_EstimatedBudgetForAdministrativeCostsId, setPR_EstimatedBudgetForAdministrativeCostsId] = useState(null)
    const dispatch = useDispatch();
    const stageGuid = useParams().stageGuid
    console.log(stageGuid, "skldkjskdjksjd");
    const BIEstimatedBudgetForAdministrativeCostsId = useSelector((state) => state.PRAdministrativeCostsReducers.PRAdministrativeCosts)

    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });
    const reportStage = useSelector((state) => state.Stages.ReportsStagesById)
    const culomEdite = ["email", "fullName"];
    const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
    const RequestsColumns = [];

    const RequestAccessor = [
        {
            KeyName: "itemName",
            ShowStatus: true,
            NmaeColumn: "البند",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "shomanContribution",
            ShowStatus: true,
            NmaeColumn: " المساهمة المطلوبة من شومان",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "totalRemainingFromSchumannSontribution",
            ShowStatus: true,
            NmaeColumn: "إجمالي المتبقي من مساهمة شومان",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "contributionRequiredFromSchumannForThisStage",
            ShowStatus: true,
            NmaeColumn: "المساهمة المطلوبة من شومان للمرحلة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "actualExchangeValueOfSchumannContributionForStage",
            ShowStatus: true,
            NmaeColumn: "قيمة الصرف الفعلي من مساهمة شومان للمرحلة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        },
        {
            KeyName: "actualDisbursementValueOfBeneficiaryContributionForStage",
            ShowStatus: true,
            NmaeColumn: "قيمة الصرف الفعلي من مساهمة المستفيد للمرحلة",
            TotalNumber: true,
            DropdownFiltration: { keyTextName: "", keyValueName: "" },
            DropdownFiltrationStatus: false,
            GroupOfColumns: false


        }
    ];

    const OtherMainBtns = [

        {
            Click: async (e) => {
                setPR_EstimatedBudgetForAdministrativeCostsId(e.target.value)
                closePopupEditComponent()
            },
            content: "",
            className: "bi bi-pencil-square",
            id: "editBtn",
            title: "عرض",
            ShowStatus: true,
        },
        {
            Click: async (e) => {
                setPR_EstimatedBudgetForAdministrativeCostsId(e.target.value)
                closePopupComment()
            },
            content: "",
            className: "bi bi-chat-left-dots-fill",
            id: "editBtn",
            title: "عرض",
            ShowStatus: true,
        },


    ];

    useEffect(() => {
        dispatch(GetReportStageByID(stageGuid))
    }, [])

    // console.log(decryptToken(stageGuid) , "sdsdsdsd");
    const PopupOPjectData = {
        isPopupOpenStatus: true,
        isPopupOpenFunction: () => { },
        componentBody: <InformationAdministrativeCosts />,
        maxWidth: "500px",
        maxHeight: "800px",
        title: "الأهداف",
    };

    const closePopupEditComponent = () => {
        if (PopupComponentEditStatus) {
            setPopupComponentEditStatus(false);
        } else {
            setPopupComponentEditStatus(true);
        }
    };

    const closePopupComment = () => {
        if (PopupComponentCommentStatus) {
            setPopupComponentCommentStatus(false);
        } else {
            setPopupComponentCommentStatus(true);
        }
    };
    return (
        <>

            {
                stageGuid ? <TableAHSF
                    culomEdite={culomEdite}
                    uniqueValue={"pR_EstimatedBudgetForAdministrativeCostsId"}
                    valueButtonAction={"pR_EstimatedBudgetForAdministrativeCostsId"}
                    URL={`api/PR_AdministrativeCostsController/GetAllPRAdministrativeCosts`}
                    UrlBody={{

                        reportStageGuid: decryptToken(stageGuid)
                    }}
                    staticKeyEdite={staticKeyEdite}
                    accessor={RequestAccessor}
                    titelTable={"معلومات الصرف للتكاليف الإدارية"}
                    selectRowNumber={true}
                    checkBoksColumName="اختيار"
                    sort={true}
                    pagination={true}
                    AppStatus={true}
                    tableBtn={false}
                    sortTable={true}
                    keyNameSort={"dateCreate"}
                    dateKey="dateCreate"
                    dateformat="DD/MM/YYYY h:mm a"
                    arrayNameSort={["applicationNumber"]}
                    search={true}
                    openPopupState={false}
                    DropdownArrayFiltration={[]}
                    DropdownFiltration={false}
                    exportData={true}
                    checkBoks={false}
                    nameColumAction=""
                    total={false}
                    arrayButton={OtherMainBtns}
                    ArrayNameDataColum={RequestsColumns}
                    columnKeyNameArray={[
                        { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
                    ]}
                    PopupOPjectData={PopupOPjectData}
                    popUpTitle={"معلومات الطلب"}
                // popUpBody2={[<ShowApplication addFun={true} />]}
                // popUpId2={"ShowApplicationpopUp"}
                // popUpBody2={[
                //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
                // ]}
                // handleCloseModal={handleCloseModal}
                // showModal={showPopUp}
                /> : <></>
            }

            <PopupAHSF
                title={BIEstimatedBudgetForAdministrativeCostsId?.bI_AB_EstimatedBudgetForAdministrativeCosts?.itemName}
                componentBody={
                    <InformationAdministrativeCosts stageGuid={decryptToken(stageGuid)} PR_EstimatedBudgetForAdministrativeCostsId={PR_EstimatedBudgetForAdministrativeCostsId} />
                }
                maxWidth="1200px"
                maxHeight="600px"
                isPopupOpenStatus={PopupComponentEditStatus}
                isPopupOpenFunction={closePopupEditComponent}
            />

            <PopupAHSF
                title={"الملاحظات"}
                componentBody={
                    <CommentPopup stageGuid={decryptToken(stageGuid)} PR_EstimatedBudgetForAdministrativeCostsId={PR_EstimatedBudgetForAdministrativeCostsId} />
                }
                maxWidth="500px"
                maxHeight="700px"
                isPopupOpenStatus={PopupComponentCommentStatus}
                isPopupOpenFunction={closePopupComment}
            />

        </>
    )
}

export default RS_AdminStrativeStage